import { useState } from 'react';
import { Alert, Button, Checkbox, Input, Select } from '@dreamtree-org/twreact-ui';
import { useMutation } from '@/lib/useQuery';
import { isValidPhone, isValidPin } from '../lib/cart';

const LABELS = [
  { value: 'Home', label: 'Home' },
  { value: 'Office', label: 'Office' },
  { value: 'Other', label: 'Other' },
];

const blank = { label: 'Home', name: '', phone: '', line1: '', line2: '', city: 'Bengaluru', state: 'Karnataka', pin: '', is_default: false };

/** Add / edit a delivery address (WEB-05, WEB-06). Calls onSaved(address). */
export default function AddressForm({ initial, onSaved, onCancel }) {
  const save = useMutation('sfAddressSave');
  const [a, setA] = useState({ ...blank, ...(initial || {}) });
  const [touched, setTouched] = useState(false);
  const set = (k) => (e) => setA((x) => ({ ...x, [k]: e && e.target ? (e.target.type === 'checkbox' ? e.target.checked : e.target.value) : e }));

  const errors = {
    name: !a.name.trim() ? 'Required' : '',
    phone: a.phone && !isValidPhone(a.phone) ? 'Enter a 10-digit mobile number' : '',
    line1: !a.line1.trim() ? 'Required' : '',
    pin: !isValidPin(a.pin) ? 'Enter a 6-digit PIN code' : '',
  };
  const invalid = Object.values(errors).some(Boolean);

  const submit = async (e) => {
    e.preventDefault();
    setTouched(true);
    if (invalid) return;
    try {
      const r = await save.run(a);
      onSaved && onSaved(r.data);
    } catch {
      /* error shown below */
    }
  };

  const err = (k) => (touched && errors[k]) || undefined;

  return (
    <form onSubmit={submit} className="space-y-3" noValidate>
      <div className="grid gap-3 sm:grid-cols-2">
        <Input label="Full name" required value={a.name} onChange={set('name')} error={err('name')} autoComplete="name" />
        <Input label="Mobile number" type="tel" value={a.phone} onChange={set('phone')} error={err('phone')} autoComplete="tel" placeholder="98765 43210" />
        <div className="sm:col-span-2">
          <Input label="Flat, house no., building, street" required value={a.line1} onChange={set('line1')} error={err('line1')} autoComplete="address-line1" />
        </div>
        <Input label="Area / locality" value={a.line2} onChange={set('line2')} autoComplete="address-line2" />
        <Input label="PIN code" type="tel" inputMode="numeric" maxLength={6} required value={a.pin} onChange={(e) => setA((x) => ({ ...x, pin: e.target.value.replace(/\D/g, '') }))} error={err('pin')} autoComplete="postal-code" />
        <Input label="City" value={a.city} onChange={set('city')} autoComplete="address-level2" />
        <Select label="Address type" options={LABELS} value={a.label} onChange={(v) => setA((x) => ({ ...x, label: v }))} closeOnSelect />
      </div>
      <Checkbox label="Make this my default address" checked={!!a.is_default} onChange={set('is_default')} />
      {save.error ? <Alert variant="error">{save.error}</Alert> : null}
      <div className="flex flex-wrap gap-2">
        <Button type="submit" loading={save.loading}>Save address</Button>
        {onCancel ? <Button variant="ghost" onClick={onCancel}>Cancel</Button> : null}
      </div>
    </form>
  );
}
